module.exports = {
    name: 'Insurance Claim Categories',
    gen_template: `
       {
          "coa": "ASSET",
          "code": "{{random.alphaNumeric}}{{random.number}}{{random.alphaNumeric}}{{random.number}}", 
          "name": "{{lorem.word}}"
       }
    `,
    wizard: {
       actionBtn: 'Save',
       action: 'add_insurace_claim_category',
       pages: [
          {
             title: 'Insurance Claim Categories',
             subtitle: 'Configure new insurance class',
             forms: [
                {
                   type: 'text', form_type: 'text', label: 'Name', model: 'name',
                   validation: 'required|min:3|max:150', class: 'col-12 col-md-6'
                },
 
                {
                   type: 'text', form_type: 'text', label: 'Code', model: 'code',
                   validation: 'required|min:1|max:50', class: 'col-12 col-md-6'
                },
                {
                   type: 'textarea', form_type: 'text', label: 'Description', model: 'description',
                   validation: 'required|min:10|max:500', class: 'col-12'
                },
             ],
          }
       ]
    },
    table: {
       title: 'Insurance Claim Categories',
       subtitle: 'A list of configured insurance claim_categories',
       table_fields: [
          { name: 'Code', align: 'l' },
          { name: 'Name', align: 'l' },
          { name: 'Description', align: 'l' },
          { name: 'actions', align: 'c' }
       ],
       searchFields: ["code", "name"],
       rowData: [
          { type: 'text', field: 'code', class: 'left bolder small' },
          { type: 'text', field: 'name', class: 'left bolder' },
          { type: 'text', field: 'description', class: 'left bolder' },
          {
             type: 'action', field: 'name', class: 'center', icon: '', actions: [
                // {type: 'title', title: 'Actions'},
              /*  {
                   type: 'menu', title: 'Edit', event: 'client:edit', icon: 'ico-right', params: [
                      { key: 'client', field: '*' }
                   ]
                },
                */
                {
                   type: 'menu', title: 'View', event: 'claimType:view', icon: 'ico-reply', params: [
                      { key: 'claimtype', field: '*' },
                   ]
                },
             
             ]
          },
       ]
    },
 }